import { useQuery, gql, ApolloError } from '@apollo/client'
import { FeatureToggleQuery, FeatureToggleQueryVariables } from '../../types'

export const FEATURE_TOGGLES = gql`
  query FeatureToggle {
    featureToggles {
      name
      enabled
    }
  }
`
export default (): { data: FeatureToggleQuery | undefined; error: ApolloError | undefined; loading: boolean } => {
  const { data, error, loading } = useQuery<FeatureToggleQuery, FeatureToggleQueryVariables>(FEATURE_TOGGLES)

  return { data, error, loading }
}
